const onlyNumbersDirective = {
	mounted(el: HTMLElement) {
		const handler = (event: KeyboardEvent) => {
			const isNumber = /\d/.test(event.key);
			const isControl = [
				'Backspace',
				'ArrowLeft',
				'ArrowRight',
				'Delete',
				'Tab',
				'Enter',
				'Control',
			].includes(event.key);

			const isCtrlV =
				event.ctrlKey &&
				(event.key === 'a' || event.key === 'c' || event.key === 'v');

			if (!isNumber && !isControl && !isCtrlV) {
				event.preventDefault();
			}
		};

		// Handler for paste event
		const pasteHandler = (event: ClipboardEvent) => {
			const pastedData = event.clipboardData?.getData('text') || '';
			if (!/^\d+$/.test(pastedData)) {
				event.preventDefault();
			}
		};

		el.addEventListener('keydown', handler);
		el.addEventListener('paste', pasteHandler);

		// Store the handler function on the element to remove it later
		(el as any).__onlyNumbersHandler__ = { handler, pasteHandler };
	},
	unmounted(el: HTMLElement) {
		const handler = (el as any).__onlyNumbersHandler__;
		if (handler) {
			el.removeEventListener('keydown', handler.keydownHandler);
			el.removeEventListener('paste', handler.pasteHandler);
		}
	},
};

export default onlyNumbersDirective;
